export const text = {
  // SPACINGS
  labelText: {
    mb: 4
  },
  alignRight: {
    textAlign: 'right'
  },
  alignCenter: {
    textAlign: 'center'
  },
  // Text Sizes
  H1: {
    fontSize: '$9',
    lineHeight: '$9'
  },
  H2: {
    fontSize: '$8',
    lineHeight: '$8'
  },
  H3: {
    fontSize: '$7',
    lineHeight: '$7'
  },
  H4: {
    fontSize: '$6',
    lineHeight: '$6'
  },
  H5: {
    fontSize: '$5',
    lineHeight: '$5'
  },
  H6: {
    fontSize: '$4',
    lineHeight: '$4'
  },
  textTitle: {
    fontSize: '$3',
    lineHeight: '$3'
  },
  textBody: {
    fontSize: '$2',
    lineHeight: '$2'
  },
  textCaption: {
    fontSize: '$1',
    lineHeight: '$1'
  },
  textSmall: {
    fontSize: '$0',
    lineHeight: '$0'
  },
  // WEIGHT
  bolder: {
    fontWeight: 700
  },
  bold: {
    fontWeight: 600
  },
  regular: {
    fontWeight: 400
  },
  // COLOR
  primary: {
    color: '$textPrimary'
  },
  secondary: {
    color: '$textSecondary'
  },
  neutral: {
    color: '$textNeutral'
  },
  success: {
    color: '$success'
  },
  error: {
    color: '$error'
  },
  disabled: {
    color: '$textDisabled'
  },
  assist: {
    color: '$textAssist'
  },
  info: {
    color: '$textInfo'
  }
};

export const htmlTexts = {
  h1: {
    fontSize: ['$7', '$8'],
    lineHeight: ['$7', '$8'],
    color: '$text',
    marginVertical: '$2'
  },
  h2: {
    fontSize: ['$6', '$8'],
    lineHeight: ['$6', '$8'],
    color: '$text',
    marginVertical: '$2'
  },
  h3: {
    fontSize: ['$5', '$7'],
    lineHeight: ['$5', '$7'],
    color: '$text',
    marginVertical: '$2'
  },
  h4: {
    fontSize: ['$4', '$6'],
    lineHeight: ['$4', '$6'],
    color: '$text',
    marginVertical: '$2'
  },
  h5: {
    fontSize: ['$3', '$4'],
    lineHeight: ['$3', '$4'],
    color: '$text',
    marginVertical: '$2'
  },
  h6: {
    fontSize: ['$2', '$3'],
    lineHeight: ['$2', '$3'],
    color: '$text',
    marginVertical: '$2'
  },
  p: {
    fontSize: '$1', // 12px from `fontSizes`
    mb: '$3', // 8px from `space`
    color: '$text'
  }
};
